import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCalendarDate } from "../store/dashboard.duck";

export function WithStartOfWeek() {
  const calendarDate = useSelector(selectCalendarDate);
  return useMemo(() => calendarDate.clone().startOf('isoWeek'), [calendarDate]);
}
